// apiEndpoints.js

const BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://54.90.92.151/api"; // Base URL for all API endpoints

const apiEndpoints = {
    auth: {
        // Authentication-related endpoints
        signup: `${BASE_URL}/register`,
        login: `${BASE_URL}/login`,
        logout: `${BASE_URL}/logout`,
    },
    dashboard: {
        // Fetch dashboard data
        getDashboard: `${BASE_URL}/dashboard`,

        // Search with query parameters
        search: (query = "", page = 1, perPage = 5, resultOrder = "Ascending") => {
            console.log(query)
            // Preserve query as-is and append additional parameters
            const additionalParams = new URLSearchParams({
                page,
                per_page: perPage,
                order: resultOrder,
            }).toString();

            // Combine query and additionalParams
            return `${BASE_URL}/search?${query}&${additionalParams}`;
        },

        // Search by lead ID
        searchByLead: (leadId) => `${BASE_URL}/search/${leadId}`,

        downloadLeads: `${BASE_URL}/enrich/download`,
        enrichLeads : `${BASE_URL}/enrich/update`,

        // Search Results
        getSeachResults: `${BASE_URL}/search2`,
        // Search Filters
        getSeachFilters: `${BASE_URL}/search_filters`,

        // Folders
        folder: `${BASE_URL}/folders`,
        folderDetail: (folder_id) => `${BASE_URL}/folders/${folder_id}`,
        folderLead: (folder_id) => `${BASE_URL}/folders/${folder_id}/leads`,
    },
};

export default apiEndpoints;
